function handleTouchPointClick(event) {
  const id = event.target.getAttribute('touch-point-id');
  const selectedTab = document.querySelector(`#touch-point-${id}`);
  const selectedTouchPoint = event.target;
  const touchPointsTab = document.querySelectorAll('.touch-points-tab');
  const touchPoints = document.querySelectorAll('.touch-point');

  touchPoints.forEach(function(el) {
    el.classList.remove('active');
  });
  selectedTouchPoint.classList.add('active');

  if (!selectedTab.classList.contains('active')) {
    touchPointsTab.forEach(function(el) {
      el.classList.remove('active');
    });
    selectedTab.classList.add('active');
  }
}